var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { EventTargetInterruptSource } from './eventtargetinterruptsource';
/*
 * An interrupt source on the Window object.
 */
export var WindowInterruptSource = (function (_super) {
    __extends(WindowInterruptSource, _super);
    function WindowInterruptSource(events, throttleDelay) {
        if (throttleDelay === void 0) { throttleDelay = 500; }
        _super.call(this, window, events, throttleDelay);
    }
    return WindowInterruptSource;
}(EventTargetInterruptSource));
//# sourceMappingURL=windowinterruptsource.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-idle/core/src/windowinterruptsource.js
// module id = 753
// module chunks = 3